import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { isFeatureActive } from '@helpers';
import { toggleDealsActivated } from '@common/ActivateDeals/actions';
import { useActiveDeal } from '@common/ActivateDeals/hooks';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslate } from '@common/Translations';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import '../styles/ActivateDealsButton.scss';

function ActivateDealsButton() {
    const config = useConfig();
    const translate = useTranslate();
    const dispatch = useDispatch();
    const deal = useActiveDeal();
    const isActivated = deal?.activated;

    const handleActivate = () => {
        dispatch(toggleDealsActivated());
        pushGAEventToDataLayer('MDV', isActivated ? 'Disable' : 'Enable', '');
    };

    if (isFeatureActive('PLT-39971-activate-deals-debug', config)) {
        // eslint-disable-next-line no-console
        console.log('isActivated', isActivated, config.serverSide);
    }

    return (
        <button
            aria-label={translate('mdv.campaign_name')}
            aria-pressed={isActivated}
            className={classNames('activate-deals-button', {
                'activate-deals-button--active': isActivated
            })}
            style={{ background: isActivated ? deal?.button_color_on : deal?.button_color }}
            type="button"
            onClick={handleActivate}
        >
            <span />
        </button>
    );
}

export default ActivateDealsButton;
